@if (registrationFormGroup()) {
    <form [formGroup]="registrationFormGroup()!">
        <div formGroupName="body" class="space-y-8 md:space-y-10 xl:space-y-20">
            @for (category of registrationForm()!.body; track category.name) {
                @if (renderCategory(category)) {
                    <fieldset [formGroupName]="category.name" class="space-y-2">
                        <legend
                            class="text-base md:text-2xl mb-4 md:mb-6 xl:mb-10 font-bold text-brand-dark-gray"
                            [class.sr-only]="
                                registrationFormType ===
                                RegistrationFormType.REGISTER
                            ">
                            <apcam-translation [model]="category.label" />
                        </legend>
                        @for (field of category.elements; track field.key) {
                            @if (renderElement(field)) {
                                <apcam-tooltip-custom
                                    [customMatTooltip]="
                                        'shared.registrationForm.registrationOnlyLockedHint'
                                            | translate
                                    "
                                    [customMatTooltipDisabled]="
                                        !shouldShowRegistrationOnlyTooltip(
                                            category,
                                            field
                                        )
                                    "
                                    [display]="'block'">
                                    @switch (field.type) {
                                        @case (ElementType.Input) {
                                            @if (
                                                $any(field)?.typeInHTML ===
                                                InputHTMLTypes.TEL
                                            ) {
                                                <apcam-phone-input
                                                    [formControlName]="
                                                        field.name.translations[
                                                            defaultLang
                                                        ]
                                                    "
                                                    [countryList]="countryList"
                                                    [priorityCountries]="
                                                        supportedCountries()
                                                    "
                                                    [showPlaceholder]="
                                                        showPlaceholders
                                                    " />
                                            } @else {
                                                <apcam-input-element
                                                    [disabled]="
                                                        field.name.translations[
                                                            defaultLang
                                                        ] === 'email' &&
                                                        !!clientProfile.email
                                                    "
                                                    [inputConfig]="
                                                        typecastToInputModel(
                                                            field
                                                        )
                                                    "
                                                    [formcontrolName]="
                                                        field.name.translations[
                                                            defaultLang
                                                        ]
                                                    "
                                                    [showPlaceholder]="
                                                        showPlaceholders
                                                    " />
                                            }
                                        }
                                        @case (ElementType.Textarea) {
                                            <apcam-textarea-element
                                                [inputConfig]="
                                                    typecastToTextareaModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                "
                                                [showPlaceholder]="
                                                    showPlaceholders
                                                " />
                                        }
                                        @case (ElementType.Select) {
                                            <apcam-select-element
                                                [inputConfig]="
                                                    typecastToElementWithOptionsModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                " />
                                        }
                                        @case (ElementType.Checkbox) {
                                            <apcam-checkbox-element
                                                [inputConfig]="
                                                    typecastToElementWithOptionsModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                "
                                                [readonlyState]="readonly"
                                                [checkboxDirty]="
                                                    checkboxDirty
                                                " />
                                        }
                                        @case (ElementType.Radio) {
                                            <apcam-radio-element
                                                [inputConfig]="
                                                    typecastToElementWithOptionsModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                " />
                                        }
                                        @case (ElementType.LanguageSelect) {
                                            <apcam-language-select-element
                                                [inputConfig]="
                                                    typecastToElementWithOptionsModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                "
                                                [supportedLanguages]="
                                                    supportedLanguages
                                                " />
                                        }
                                        @case (ElementType.CountrySelect) {
                                            <apcam-country-select-element
                                                [inputConfig]="
                                                    typecastToElementWithOptionsModel(
                                                        field
                                                    )
                                                "
                                                [formcontrolName]="
                                                    field.name.translations[
                                                        defaultLang
                                                    ]
                                                "
                                                [countryList]="countryList" />
                                        }
                                    }
                                </apcam-tooltip-custom>
                            }
                        }
                    </fieldset>
                }
            }
        </div>
        @if (
            registrationFormType === RegistrationFormType.REGISTER &&
            !skipConsentCheckbox
        ) {
            <div formGroupName="bottom" class="flex gap-2">
                <div class="text-xs h-[1lh] flex justify-center items-center">
                    <input
                        id="checkbox"
                        type="checkbox"
                        formControlName="checked"
                        class="shrink-0 appearance-none w-2.5 h-2.5 rounded-full border border-solid border-brand-red checked:bg-brand-red focus:ring-2 focus:ring-brand-red-200" />
                </div>
                <label
                    for="checkbox"
                    class="text-xs [&>*]:text-xs [&>*]:mb-0 [&_a]:text-blue-500"
                    [innerHTML]="checkboxLabelHTML()">
                </label>
            </div>
            @if (
                registrationFormGroup()?.get('bottom')?.get('checked')
                    ?.touched &&
                registrationFormGroup()
                    ?.get('bottom')
                    ?.get('checked')
                    ?.hasError('required')
            ) {
                <mat-error>
                    {{ 'shared.validation.required' | translate }}
                </mat-error>
            }
        }
        @if (allowEdit()) {
            @if (registrationFormType === RegistrationFormType.EDIT) {
                <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    class="my-4 mr-4 text-brand-beige"
                    (click)="toggleReadonly()"
                    [disabled]="submitting()">
                    {{
                        (readonly()
                            ? 'shared.buttons.edit'
                            : 'shared.buttons.cancel'
                        ) | translate
                    }}
                </button>
            }
            <button
                mat-raised-button
                color="primary"
                type="button"
                class="my-4 text-brand-beige"
                (click)="handleSubmit()"
                [disabled]="
                    readonly() ||
                    submitDisabled() ||
                    submitting() ||
                    (registrationFormType === RegistrationFormType.EDIT &&
                        !readonly() &&
                        !registrationFormGroup()?.dirty &&
                        !checkboxDirty()) ||
                    (registrationFormType === RegistrationFormType.EDIT &&
                        clientProfile.status !==
                            ClientProfileStatus.ActionRequired &&
                        clientProfile.status !==
                            ClientProfileStatus.RequiredDataSubmitted)
                ">
                @if (submitting()) {
                    <mat-icon>
                        <apcam-loading-spinner size="xs" />
                    </mat-icon>
                }
                @if (
                    registrationFormType === RegistrationFormType.REGISTER &&
                    confirmButtonTranslationKey === null
                ) {
                    <apcam-translation
                        [model]="registrationForm()!.bottom.submitButtonText" />
                } @else {
                    {{
                        confirmButtonTranslationKey ?? 'shared.buttons.save'
                            | translate
                    }}
                }
            </button>
        }
    </form>
} @else {
    <apcam-loading-spinner centered />
}
